module.exports = __webpack_public_path__ + "img/animato.8bc32ceb.png";